import { Tabs } from 'antd';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './../styles/LoyaltyProgram.module.scss'
import TransferProgramsLoyalty from './Transfers/TransferProgramsLoyalty';
import TransferActions from './Transfers/TransferActions';
import TransferTypeCards from './Transfers/TransferTypeCards';
import { ICompatibilityTabs } from '../interface';

const CompatibilityTabs: React.FC<ICompatibilityTabs> = ({data, onIncompatibleProgramsChange, onIncompatibleDiscount2ProgramsChange, onIncompatibleDiscount2CardTypeChange }) => {

    const [activeCompatibilityItemsTab, setActiveCompatibilityItemsTab] = useState<string>('1');

    const [selectedActions, setSelectedActions] = useState<string[]>([]);
    const [selectedTypeCards, setSelectedTypeCards] = useState<string[]>([]);
    const [selectedPrograms, setSelectedPrograms] = useState<string[]>([]);
    
    const { t } = useTranslation();    
    const baseT = (value: string) => t('directory.loyaltyProgram.' + value)

    useEffect(() => {
        if (data?.incompatibleDiscount2Program) {
            setSelectedActions(data.incompatibleDiscount2Program);
        }
        if (data?.incompatibleDiscount2CardType) {
            setSelectedTypeCards(data.incompatibleDiscount2CardType);
        }
        if (data?.incompatibleLoyaltyProgram) {
            setSelectedPrograms(data.incompatibleLoyaltyProgram);
        }
    }, [data]);
    
    const handleActionsChange = (newSelectedIds: string[]) => {
        setSelectedActions(newSelectedIds);
        if (onIncompatibleDiscount2ProgramsChange) {
            onIncompatibleDiscount2ProgramsChange(newSelectedIds);
        }
    };

    const handleTypeCardsChange = (newSelectedIds: string[]) => {
        setSelectedTypeCards(newSelectedIds);
        if (onIncompatibleDiscount2CardTypeChange) {
            onIncompatibleDiscount2CardTypeChange(newSelectedIds);
        }
    };
    
    const handleProgramsChange = (newSelectedIds: string[]) => {
        setSelectedPrograms(newSelectedIds);
        if (onIncompatibleProgramsChange) {
            onIncompatibleProgramsChange(newSelectedIds);
        }
    };

    const tabCompatibilityItems = [
        {
            key: '1',
            label: baseT('actions'),
            children: (
                <div>
                    <div className={styles.compatibilityBlockWrapper}>
                        <div className={styles.compatibility}>{baseT('isCompatibility')}</div>
                        <div className={styles.unCompatibility}>{baseT('isNotCompatibility')}</div>
                    </div>
                    <TransferActions
                        value={selectedActions}
                        onChange={handleActionsChange}
                        data={data}
                    />
                </div>
            )
        },
        {
            key: '2',
            label: baseT('typeCards'),
            children: (
                <div>
                    <div className={styles.compatibilityBlockWrapper}>
                        <div className={styles.compatibility}>{baseT('isCompatibility')}</div>
                        <div className={styles.unCompatibility}>{baseT('isNotCompatibility')}</div>
                    </div>
                    <TransferTypeCards
                        value={selectedTypeCards}
                        onChange={handleTypeCardsChange}
                    />
                </div>
            )
        },
        {
            key: '3',
            label: baseT('programsLoyalty'),
            children: (
                <div>
                    <div className={styles.compatibilityBlockWrapper}>
                        <div className={styles.compatibility}>{baseT('isCompatibility')}</div>
                        <div className={styles.unCompatibility}>{baseT('isNotCompatibility')}</div>
                    </div>
                    <TransferProgramsLoyalty
                        idGlobalPL={data?.idGlobal}
                        value={selectedPrograms}
                        onChange={handleProgramsChange}
                        data={data}
                    />
                </div>
            )
        },
    ]
    
    return (
        <Tabs
            activeKey={activeCompatibilityItemsTab}
            onChange={setActiveCompatibilityItemsTab}
            type="card"
            items={tabCompatibilityItems}
        />
    )
}
export default CompatibilityTabs